export default {
  getInventory: state => state.items,
  getLots: state => state.lots
}
